import app from "@/common/plugins/vueInstance";

import "vue-datepicker-next/index.css";
import "vue-datepicker-next/locale/pt-br";
import DatePicker from "vue-datepicker-next";

app.component("date-picker", DatePicker);
